interface IAdminDetails {
  first: string;
  last: string;
  email: string;
  account_type: string;
  schoolIDs: string[];
  districtID: string;
}

interface IBasicDmLicense {
  expiration: number;
  has_integral: boolean;
}

interface ISchoolAdminDetails {
  schoolid: string;
  schoolName: string;
  dmLicense?: IBasicDmLicense;
}

interface IDistrictAdminDetails {
  districtID: string;
  districtName: string;
  dmLicense?: IBasicDmLicense;
}

export interface ITeacherAdminDetails {
  admin: IAdminDetails;
  schools: ISchoolAdminDetails[];
  district: IDistrictAdminDetails;
}

export const TeacherAdminDetails: React.FC<ITeacherAdminDetails> = ({
  admin,
  schools,
  district,
}) => {
  return (
    <div className="flex flex-col gap-4 p-6">
      <h2 className="text-xl font-bold">Admin Details</h2>
      <div className="flex flex-col gap-2">
        <p>
          <strong>Name:</strong> {admin.first} {admin.last}
        </p>
        <p>
          <strong>Email:</strong> {admin.email}
        </p>
        <p>
          <strong>Account Type:</strong> {admin.account_type}
        </p>
      </div>
      {schools.length > 0 && (
        <>
          <h3 className="text-lg font-semibold">School Info</h3>
          <ul className="list-disc pl-6">
            {schools.map((school) => (
              <li key={school.schoolid}>
                <p>
                  <strong>School ID:</strong> {school.schoolid}
                </p>
                <p>
                  <strong>School Name:</strong> {school.schoolName}
                </p>
                {school.dmLicense && (
                  <>
                    <p>
                      <strong>Site License Expiration:</strong>{" "}
                      {new Date(
                        school.dmLicense.expiration
                      ).toLocaleDateString()}
                    </p>
                    <p>
                      <strong>Tier:</strong>{" "}
                      {school.dmLicense.has_integral ? "INTEGRAL" : "PLUS"}
                    </p>
                  </>
                )}
              </li>
            ))}
          </ul>
        </>
      )}
      <h3 className="text-lg font-semibold">District Info</h3>
      <div>
        <p>
          <strong>District ID:</strong> {district.districtID}
        </p>
        <p>
          <strong>District Name:</strong> {district.districtName}
        </p>
        {district.dmLicense && (
          <>
            <p>
              <strong>Site License Expiration:</strong>{" "}
              {new Date(district.dmLicense.expiration).toLocaleDateString()}
            </p>
            <p>
              <strong>Tier:</strong>{" "}
              {district.dmLicense.has_integral ? "INTEGRAL" : "PLUS"}
            </p>
          </>
        )}
      </div>
    </div>
  );
};
